// extracted by mini-css-extract-plugin
module.exports =  {"title":"EHwj2B","formContainer":"gXi7lj","form":"iEwpbA","textArea":"FEbBtw"};